import React from 'react';
import { observer } from '@poa/state';

export const ProfileModalRightCorner = observer(props => {
  return (
    <div className="popup__right-corner">
      <span className="no-edition">
        {!props.state.isEditMode &&
          !props.state.isEmpty && (
            <button className="popup__btn popup__btn_edit js-popup-edit" onClick={props.onEdit}>
              <svg
                className="icon icon-pencil"
                id="icon-pencil"
                viewBox="0 0 15 15"
                width="100%"
                height="100%"
              >
                <path d="M8.71 2.34l2.84 2.86-7.21 7.24L1.5 9.58zm5 .69L12.3 4.45 9.45 1.59 10.66.37c.5-.49 1.29-.49 1.78 0l1.27 1.28c.39.38.39 1 0 1.38zM.01 13.6c-.05.24.16.45.39.39l3.17-.77-2.84-2.86z" />
              </svg>
            </button>
          )}
        {props.state.isEditMode && (
          <button
            className="popup__btn popup__btn_cancel js-popup-edit-cancel"
            onClick={props.onCancel}
          >
            <svg
              className="icon icon-cancel"
              id="icon-cancel"
              viewBox="0 0 15.5 15.5"
              width="100%"
              height="100%"
            >
              <path d="M7.75.25A7.5 7.5 0 0 0 2.31 2.6l-.03.02A7.45 7.45 0 0 0 .25 7.75a7.5 7.5 0 1 0 7.5-7.5zm-6.29 7.5c0-1.43.48-2.75 1.29-3.81l8.81 8.81a6.3 6.3 0 0 1-10.1-5zm10.98 4.17L3.58 3.06a6.3 6.3 0 0 1 8.86 8.86z" />
              <path
                strokeMiterlimit="50"
                strokeWidth=".5"
                d="M7.75.25A7.5 7.5 0 0 0 2.31 2.6l-.03.02A7.45 7.45 0 0 0 .25 7.75a7.5 7.5 0 1 0 7.5-7.5zm-6.29 7.5c0-1.43.48-2.75 1.29-3.81l8.81 8.81a6.3 6.3 0 0 1-10.1-5zm10.98 4.17L3.58 3.06a6.3 6.3 0 0 1 8.86 8.86z"
              />
            </svg>
          </button>
        )}
        {props.state.isEditMode &&
          props.state.isFormValid && (
            <button
              className="popup__btn popup__btn_save js-popup-edit-save"
              onClick={props.onSave}
            >
              <svg
                className="icon icon-like"
                id="icon-like"
                viewBox="0 0 14.53 10"
                width="100%"
                height="100%"
              >
                <path d="M12.74 1.18a.6.6 0 0 0-.86 0L4.6 8.46l-2.8-2.8a.62.62 0 0 0-.86 0 .6.6 0 0 0 0 .86l3.23 3.23a.6.6 0 0 0 .86 0l7.71-7.71a.6.6 0 0 0 0-.86z" />
                <path
                  strokeMiterlimit="50"
                  strokeWidth="2"
                  d="M1239.98 296.18a.6.6 0 0 0-.86 0l-7.28 7.28-2.8-2.8a.62.62 0 0 0-.86 0 .6.6 0 0 0 0 .86l3.23 3.23a.6.6 0 0 0 .86 0l7.71-7.71a.6.6 0 0 0 0-.86z"
                  clipPath="url(&quot;#a&quot;)"
                  transform="translate(-1227.24 -295)"
                />
              </svg>
            </button>
          )}
      </span>
      <button className="popup__btn popup__btn_close js-popup-close" onClick={props.onClose}>
        <svg
          className="icon icon-cross"
          id="icon-like"
          viewBox="0 0 16 15"
          width="100%"
          height="100%"
        >
          <path d="M16 8.63H9.17V15H6.79V8.63H0v-2.3h6.79V0h2.42v6.33H16z" />
        </svg>
      </button>
    </div>
  );
});
